<!--
 * @Description:
 * @Version: 2.0
 * @Autor: dudedu
 * @Date: 2022-10-28 10:01:39
 * @LastEditors: dudedu
 * @LastEditTime: 2023-10-05 16:46:19
-->
<template>
  <div>
    <el-container class="workbench">
      <!-- 水印载体 -->
      <div class="watermark-light"></div>
      <div class="watermark-dark"></div>
      <!-- 远程桌面头部内容 -->
      <el-header class="base-background__white">
        <img alt="" class="logo_style" src="@/views/remoteDestop/image/logo.png">
        <div class="icon base-flex__cross-center">
          <el-popover
            placement="bottom"
            trigger="click"
            width="400">
            <el-input
              v-model="textareaData"
              :rows="16"
              placeholder="粘贴内容在远程使用"
              type="textarea"
              @change="textareaChange">
            </el-input>
            <img v-if="ifTextareaShow" slot="reference" alt="粘贴版" src="@/views/remoteDestop/image/clipboard.png">
          </el-popover>
          <span v-if="remoteProtocol === 'rdp'" class="base-flex__cross-center base-margin__right-20">
            <span class="base-width__100">当前分辨率:</span><el-input v-model="windowsResolution"
                                                                      class="windowsResolution_input"
                                                                      placeholder="分辨率"
                                                                      @change="changeWindowsResolution"></el-input>
          </span>
          <img alt="上传" src="@/views/remoteDestop/image/upload.png" title="上传" @click="openUpload">
          <img v-if="machineImageTypeWindows" alt="下载" src="@/views/remoteDestop/image/download.png" title="下载"
               @click="openDownload">
          <img v-if="remoteProtocol === 'vnc'" alt="文件下载申请" src="@/views/remoteDestop/image/download.png"
               title="文件下载申请" @click="openApplyDownload">
          <img alt="授权码" src="@/views/remoteDestop/image/cloud-upload.png" title="授权码" @click="uploadCos">
          <img v-if="remoteProtocol === 'vnc'" alt="同步数据" src="@/views/remoteDestop/image/refresh.png"
               title="同步数据" @click="syncCos">
        </div>
      </el-header>

      <!-- 远程桌面主体内容 -->
      <el-main>
        <novnc v-if="remoteProtocol === 'vnc'"></novnc>
        <!--       <mstsc v-if="remoteProtocol === 'rdp'"></mstsc>-->
        <guac-client v-if="remoteProtocol === 'rdp'" ref="guacClient"
                     :getWindowsResolution="getWindowsResolution"></guac-client>
      </el-main>

      <!-- COSBrowser上传弹窗 -->
      <el-dialog :visible.sync="dialogAuthCodeVisible" class="cos-dialog_style" title="通过COSBrowser云端上传"
                 width="700px">
        <span>COSBrowser是腾讯云提供的对象存储可视化工具，
          <span class="goCosBrowserCls" @click="goCosBrowser">点击下载</span>
        </span>
        <h3>登录码</h3>
        <div class="position_relative">
          <div class="cos-dialog-div_style height__94">
            {{ authCode }}
            <!--          <i v-if="authCode !== ''" class="el-icon-copy-document copy-icon" @click="copy(authCode)"></i>-->
          </div>
        </div>
        <!--      <h3>上传路径</h3>-->
        <!--      <div class="cos-dialog-div_style position_relative height__32">-->
        <!--        {{cosPath}}-->
        <!--        <i v-if="cosPath !== ''" class="el-icon-copy-document copy-icon" @click="copy(cosPath)"></i>-->
        <!--      </div>-->
        <!--      <h3>存储路径</h3>-->
        <!--      <div class="cos-dialog-div_style position_relative height__32">-->
        <!--        {{uploadPath}}-->
        <!--        <i v-if="uploadPath !== ''" class="el-icon-copy-document copy-icon" @click="copy(uploadPath)"></i>-->
        <!--      </div>-->
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogAuthCodeVisible=false">取 消</el-button>
          <el-button type="primary" @click="copy(authCode)">复 制</el-button>
          <!--        <el-button @click="dialogAuthCodeVisible=false" type="primary">打开COSBrowser</el-button>-->
        </div>
      </el-dialog>
    </el-container>

    <!-- 上传文件弹窗 -->
    <uploadFile ref="uploadFileRef" :handleClose="handleClose" :homePath="homePath"
                :linuxName="linuxName" :machineImageTypeWindows="machineImageTypeWindows"></uploadFile>
    <!-- 申请列表 -->
    <applyDownload
      ref="downloadApplyRef"
      :homePath="homePath"
      :linuxName="linuxName"
    ></applyDownload>
    <!-- 下载文件弹窗 -->
    <downloadFile
      ref="downloadFileRef"
    ></downloadFile>
  </div>
</template>

<script>
import novnc from '@/views/remoteDestop/components/novnc';
import GuacClient from '@/views/remoteDestop/components/guacClient';
// import mstsc from '@/views/remoteDestop/components/mstsc';
import uploadFile from '@/views/remoteDestop/components/uploadFile';
import downloadFile from '@/views/remoteDestop/components/downloadFile';
import applyDownload from '@/views/remoteDestop/components/applyDownload';
import { UTIL } from '@/common/utils';
import { getRequest, postRequest } from '@/common/libs/request';
import { debounce } from '@/common/utils/utils';
import { BlindWatermark } from 'watermark-js-plus';

export default {
  name: 'App',
  components: {
    novnc,
    // mstsc,
    GuacClient,
    uploadFile,
    downloadFile,
    applyDownload,
  },
  data() {
    return {
      dialogAuthCodeVisible: false, // COSBrowser上传弹窗是否显示
      projectId: 0, // 项目id
      authCode: '', // 登录码
      cosPath: '', // cos上传路径
      uploadPath: '', // 存储路径
      dialogUploadVisible: false, // 上传文件弹窗是否显示
      uploadFileList: [], // 上传文件列表
      uploadLoading: false, // 上传文件loading
      remoteProtocol: '', // 渲染对象， novnc：vnc渲染  metsc：rdp渲染
      textareaData: '',
      ifTextareaShow: window.navigator.userAgent.indexOf('Firefox') !== -1,
      linuxName: '',
      homePath: '',
      machineImageTypeWindows: false, // 机器镜像类型
      watermarkShow: 0, // 水印显示
      windowsResolution: 0,
    };
  },
  computed: {},
  async mounted() {
    const { instanceId } = this.$route.query;
    try {
      await postRequest('/api/eda/common/project/cacheUserInstance', { instanceId });
      const data = await this.$store.dispatch('app/getProjectInfo', {
        instanceId,
      });

      this.linuxName = data.linuxName;
      this.homePath = data.settings.homePath;
      this.machineImageTypeWindows = data.imagePlatform === 'windows';
      this.remoteProtocol = data.imagePlatform === 'windows' ? 'rdp' : 'vnc';
    } catch (e) {

    }
    this.getTeamInfo();
  },
  methods: {
    /**
     * 修改分辨率
     */
    changeWindowsResolution() {
      this.$refs.guacClient.windowsResolution(this.windowsResolution);
    },

    /**
     * 动态获取分辨率
     */
    getWindowsResolution(val) {
      this.windowsResolution = val;
    },

    /**
     * 初始化，获取团队信息
     */
    async getTeamInfo() {
      try {
        const res = await getRequest('/api/eda/common/project/getProjectInfo');
        if (res.settings && res.settings.watermark === '1') {
          const userInfo = await getRequest('/api/eda/common/eda/getUserInfo');
          console.log('水印加载');
          this.$nextTick(function () {
            this.createWatermark('.watermark-light', false, `${userInfo.nickName}-${userInfo.email}`);
            this.createWatermark('.watermark-dark', true, `${userInfo.nickName}-${userInfo.email}`);
          });
        } else {
          console.log('水印未加载', 1);
        }
      } catch (e) {
        console.log('水印未加载', 2);
      }
    },
    /**
     * 水印添加
     */
    createWatermark(element, isDark, userName) {
      const watermark = new BlindWatermark({
        parent: element,
        content: userName,
        width: 200,
        height: 200,
        rotate: 22,
        fontColor: isDark ? '#fff' : '#000',
        layout: 'grid',
        gridLayoutOptions: {
          rows: 2,
          cols: 2,
          gap: [20, 20],
          matrix: isDark
            ? [
              [1, 0],
              [0, 1],
            ]
            : [
              [0, 1],
              [1, 0],
            ],
        },
      });

      watermark.create();
    },
    /**
     * 打开下载文件列表
     */
    openDownload() {
      this.$refs.downloadFileRef.openDownload();
    },
    /**
     * 打开申请文件列表
     */
    openApplyDownload() {
      this.$refs.downloadApplyRef.openApplyDownload();
    },

    async textareaChange(e) {
      this.$eventBus.$emit('COSBrowserCopyData', e);
    },
    /**
     * cos上传
     */
    async uploadCos() {
      this.dialogAuthCodeVisible = true;
      await this.getAuthCode();
    },

    /**
     * 弹窗关闭
     */
    handleClose(type) {
      this.dialogUploadVisible = false;
      this.uploadFileList = [];
      if (type && this.remoteProtocol === 'vnc') {
        this.syncCos();
      }
    },

    /**
     * 打开上传文件弹窗
     */
    openUpload() {
      this.$refs.uploadFileRef.openDialogUploadVisible();
    },

    /**
     * 同步数据
     */
    syncCos() {
      debounce(async () => {
        postRequest('/api/eda/common/project/syncCos').then(((res) => {
          this.$message.success('同步成功');
          this.authCode = res?.authCode || '';
        }));
      }, 500);
    },

    /**
     * 获取登录码
     */
    async getAuthCode() {
      try {
        const res = await postRequest('/api/eda/common/project/getAuthCode');
        if (res) {
          this.authCode = res?.authCode || '';
          this.cosPath = res?.cosPath || '';
          this.uploadPath = `/home/${res.cosDir}/uploads/`;
        }
      } catch (e) {
        this.$message('获取登录码失败，请重新再试');
      }
    },

    /**
     * 复制文本
     * @param val 文本信息
     */
    copy(val) {
      this.$eventBus.$emit('COSBrowserCopyData', val);
      UTIL.copyText(this, val);
    },

    /**
     * 去往下载cosBrowser页面
     */
    goCosBrowser() {
      window.open('https://www.tencentcloud.com/zh/document/product/436/11366', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>

// 远程桌面整体样式
.workbench {
  width: 100%;
  height: 100%;

  h3 {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 24px;
    margin-top: 10px;
  }

  .el-header {
    height: 46px !important;
    display: flex;
    justify-content: space-between;
    padding: 0 30px 0 20px;
    align-items: center;
  }

  .el-main {
    padding: 0;
    height: calc(100vh - 46px);

    #screen {
      height: 100%;
    }
  }

  // 远程桌面头部右侧图标样式
  .icon {
    img {
      margin-right: 26px;
      cursor: pointer;
      height: 24px;
    }
  }

  // cos上传弹窗样式
  .cos-dialog_style {
    text-align: left;

    ::v-deep .el-dialog {
      .el-dialog__body {
        padding: 16px 20px;
      }
    }
  }

  // cos上传弹窗里div样式
  .cos-dialog-div_style {
    border: 1px solid #D6D6D6;
    overflow: auto;
    padding: 0 10px;
    line-height: 30px;

    // 复制图标样式
    .copy-icon {
      position: absolute;
      right: 16px;
      bottom: 8px;
      color: #0052D9;
      cursor: pointer;
    }
  }

  // 标题样式
  .title {
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
  }

  // 上传文件弹窗头部样式
  .dialogEDA ::v-deep .el-dialog__header {
    text-align: left;
  }
}

// 相对定位样式
.position_relative {
  position: relative;
}

// logo图标样式
.logo_style {
  height: 30px;
}

// 消息提示样式
.workbench-tips__style {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;

  // 消息提示图标样式
  .tips-title_style {
    margin-right: 10px;
    position: relative;
    bottom: -1px;
  }
}

// 连接正常消息提示样式
.normal_style {
  color: #0052D9;
  background: #ECF2FE;
}

// 连接失败消息提示样式
.err_style {
  color: #c93535;
  background: #FFEAEA;
}

// 高度94px
.height__94 {
  height: 350px;
}

// 高度32px
.height__32 {
  height: 32px;
}

.goCosBrowserCls {
  cursor: pointer;
  color: #3474CD;
}

.windowsResolution_input {
  width: 70px;
}

</style>
